import OpenSourceCreditEntry from './open-source-credit-entry';

export default class OpenSourceCreditEntries {
  title?: string | null;
  openSourceEntries: OpenSourceCreditEntry[];

  constructor(props: any) {
    this.title = props.title ? props.title : null;
    this.openSourceEntries = props?.openSourceEntryCollection?.items || [];
  }
}
